import { EuiBottomBar } from '@elastic/eui';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default (props: {
  onPresAvanti: any;
  enabled: boolean;
  step: number;
  partenza?: string;
  arrivo?: string;
}) => {
  const { onPresAvanti, enabled } = props;
  const [double, setDouble] = useState(false);

  switch (props.step) {
    case 1:
      return (
        <EuiBottomBar paddingSize='s'>
          <button
            className='myButton2'
            disabled={!enabled}
            onClick={onPresAvanti}
          >
            Conferma
          </button>
        </EuiBottomBar>
        // <div>
        //   <div className='center'>
        //     <button
        //       className='myButton2'
        //       disabled={!enabled}
        //       onClick={onPresAvanti}
        //     >
        //       Conferma
        //     </button>
        //   </div>
        // </div>
      );
    case 4:
      return (
        <div>
          <div className='center'>
            {/* <button className='myButton2' onClick={onPresAvanti}>
              Conferma
            </button> */}
            <button
              className='myButton2'
              disabled={double}
              onClick={() => {
                setDouble(true);
                props.onPresAvanti();
              }}
            >
              Continua
            </button>
          </div>
        </div>
      );

    default:
      return (
        <EuiBottomBar paddingSize='s'>
          <button
            className='myButton2'
            disabled={double}
            onClick={() => {
              setDouble(true);
              props.onPresAvanti();
            }}
          >
            Continua
          </button>
        </EuiBottomBar>
        // <div>

        //   <div className='center'>
        //     <button
        //       // className='myButton2'
        //       // disabled={!enabled}
        //       // onClick={onPresAvanti}
        //       className='myButton2'
        //       disabled={double}
        //       onClick={() => {
        //         setDouble(true);
        //         props.onPresAvanti();
        //       }}
        //     >
        //       Continua
        //     </button>
        //   </div>
        //</div>
      );
  }
};
